import util from '@bmp-vue/core/api/util'

const controller = 'Arrays'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  DecisaoAnalise: [
    {
      value: 'Aprovado',
      text: 'Aprovado',
      cor: 'success',
      icone: 'mdi-check-circle-outline',
      mensagem: 'A análise interna foi concluída sem apontamentos.'
    },
    {
      value: 'Reprovado',
      text: 'Reprovado',
      cor: 'error',
      icone: 'mdi-close-circle-outline',
      mensagem: 'Reprovado por Políticas Internas. Esta informação é confidencial e não pode ser compartilhada.'
    },
    {
      value: 'Pendente de Mesa',
      text: 'Pendente de Mesa',
      cor: 'warning',
      icone: 'mdi-clock-outline',
      mensagem: 'Em análise manual pelo time da BMP. Em breve o status será atualizado.'
    },
    {
      value: 'Pendente',
      text: 'Pendente',
      cor: 'warning',
      icone: 'mdi-clock-outline',
      mensagem: 'A análise ainda está em andamento. Aguarde a conclusão para finalizar a solicitação.'
    }
  ],
  TiposDesconto: [
    { value: 0, text: 'Isento' },
    { value: 1, text: 'Valor fixo até a data informada' },
    { value: 2, text: 'Percentual até a data informada' },
    { value: 3, text: 'Valor por antecipação dia corrido' },
    { value: 5, text: 'Percentual por antecipação dia corrido' }
  ],
  SituacaoBloqueio: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Executando' },
    { value: 3, text: 'Vigente' },
    { value: 4, text: 'Finalizado' },
    { value: 99, text: 'Erro' }
  ],
  SituacaoBoletoPagadorEletronico: [
    { value: 1, text: 'A vencer' },
    { value: 2, text: 'Vencido' }
  ],
  SituacaoPagadorEletronico: [
    { value: null, text: 'Sem adesão' },
    { value: 0, text: 'Sem adesão' },
    { value: 1, text: 'Em ativação' },
    { value: 2, text: 'Ativo' },
    { value: 3, text: 'Erro ativação' },
    { value: 4, text: 'Em exclusão' },
    { value: 5, text: 'Excluído' },
    { value: 6, text: 'Erro exclusão' }
  ],
  TiposJuros: [
    { value: 5, text: 'Isento' },
    { value: 6, text: 'Valor (dia útil)' },
    { value: 1, text: 'Valor (dias corridos)' },
    { value: 8, text: 'Percentual ao mês (dias úteis)' },
    { value: 3, text: 'Percentual ao mês (dias corridos)' }
  ],
  TiposMulta: [
    { value: 3, text: 'Isenta' },
    { value: 1, text: 'Valor Fixo' },
    { value: 2, text: 'Percentual' }
  ],
  TipoSacadorAvalista: [
    { value: 0, text: 'Isento' },
    { value: 1, text: 'CPF' },
    { value: 2, text: 'CNPJ' },
    { value: 3, text: 'PIS/PASEP' },
    { value: 9, text: 'Outros' }
  ],
  SituacaoTicketRetorno: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Sucesso' },
    { value: 2, text: 'Erro' },
    { value: 3, text: 'Agendada' },
    { value: 4, text: 'Aguardando aprovação' },
    { value: 5, text: 'Cancelada' },
    { value: 6, text: 'Reprovada' },
    { value: 7, text: 'Aguardando Retorno' }
  ],
  TiposArquivo: [
    { value: 1, text: 'CNAB 240' },
    { value: 2, text: 'CNAB 400' }
  ],
  TiposPagamento: [
    { value: 1, text: 'A vista' },
    { value: 2, text: 'Vencimento determinado' },
    { value: 3, text: 'Carnê' }
  ],
  TiposPessoa: [
    { value: 1, text: 'PF' },
    { value: 2, text: 'PJ' }
  ],
  TiposConta: [
    { value: 1, text: 'Corrente' },
    { value: 2, text: 'Poupança' },
    { value: 3, text: 'Pagamento' }
  ],
  TiposSituacao: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  TiposSituacaoBooleano: [
    { value: true, text: 'Ativado' },
    { value: false, text: 'Desativado' }
  ],
  SituacaoOperadorFrontEnd: [
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Inativo' },
    { value: 3, text: 'Pendente Restritivo' },
    { value: 4, text: 'Aguardando Análise' },
    { value: 5, text: 'Recusado' }
  ],
  SituacaoOperadorRetaguarda: [
    { value: 0, text: 'Cadastrado' },
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Inativo' },
    { value: 3, text: 'Pendente Restritivo' },
    { value: 4, text: 'Aguardando Análise' },
    { value: 5, text: 'Recusado' }
  ],
  StatusSituacao: [
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Inativo' }
  ],
  SituacaoConta: [
    { value: 1, text: 'Ativa' },
    { value: 2, text: 'Inativa' },
    { value: 3, text: 'Fechada' },
    { value: 4, text: 'Cadastrada' }
  ],
  PeriodoFiltroFuturo: [
    { value: 1, text: 'Mês Atual' },
    { value: 2, text: 'Período Customizado' }
  ],
  SituacaoAprovacoes: [
    { value: 'Todas', text: 'Todas' },
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Aprovado' },
    { value: 2, text: 'Reprovado' },
    { value: 3, text: 'Cancelada' }
  ],
  OperacaoConsulta: [
    { value: 1, text: 'Transferência Interna' },
    { value: 2, text: 'Envio TED' },
    { value: 3, text: 'Pagamento de Boleto' },
    { value: 5, text: 'Pix' }
  ],
  SituacaoAgendamento: [
    { value: 'Todas', text: 'Todas' },
    { value: 32, text: 'Agendado' },
    { value: 42, text: 'Executado' },
    { value: 34, text: 'Cancelado' }
  ],
  TiposEndereco: [
    { value: 1, text: 'Residencial' },
    { value: 2, text: 'Trabalho' }
  ],
  TiposResidencia: [
    { value: 1, text: 'Alugada' },
    { value: 2, text: 'Própria' },
    { value: 3, text: 'Financiada' },
    { value: 4, text: 'Casa funcional' }
  ],
  Sexo: [
    { value: 'M', text: 'Masculino' },
    { value: 'F', text: 'Feminino' }
  ],
  TiposFeriado: [
    { value: 1, text: 'Nacional' },
    { value: 2, text: 'Estadual' },
    { value: 3, text: 'Municipal' }
  ],
  TiposLancamentos: [
    { value: 'C', text: 'Crédito' },
    { value: 'D', text: 'Débito' }
  ],
  TiposTED: [
    { value: 1, text: 'TED-PAG' },
    { value: 2, text: 'TED-STR' }
  ],
  UFS: [
    { value: 'AC', text: 'AC' },
    { value: 'AL', text: 'AL' },
    { value: 'AM', text: 'AM' },
    { value: 'AP', text: 'AP' },
    { value: 'BA', text: 'BA' },
    { value: 'CE', text: 'CE' },
    { value: 'DF', text: 'DF' },
    { value: 'ES', text: 'ES' },
    { value: 'GO', text: 'GO' },
    { value: 'MA', text: 'MA' },
    { value: 'MG', text: 'MG' },
    { value: 'MS', text: 'MS' },
    { value: 'MT', text: 'MT' },
    { value: 'PA', text: 'PA' },
    { value: 'PB', text: 'PB' },
    { value: 'PE', text: 'PE' },
    { value: 'PI', text: 'PI' },
    { value: 'PR', text: 'PR' },
    { value: 'RJ', text: 'RJ' },
    { value: 'RN', text: 'RN' },
    { value: 'RO', text: 'RO' },
    { value: 'RR', text: 'RR' },
    { value: 'RS', text: 'RS' },
    { value: 'SC', text: 'SC' },
    { value: 'SE', text: 'SE' },
    { value: 'SP', text: 'SP' },
    { value: 'TO', text: 'TO' }
  ],
  ModeloCobrancaTaxa: [
    { value: 0, text: 'Desativado' },
    { value: 1, text: 'Parceiro' },
    { value: 2, text: 'Cliente' }
  ],
  TiposTransacao: [
    { value: 1, text: 'Transferência' },
    { value: 4, text: 'Transferência - conta reserva' },
    { value: 2, text: 'TED' },
    { value: 3, text: 'Boleto' },
    { value: 6, text: 'Boleto - concessionária' },
    { value: 5, text: 'Pix' }
  ],
  TiposRecebimentoValorDivergente: [
    { value: 1, text: 'Qualquer valor' },
    { value: 2, text: 'Entre o mínimo e o máximo' },
    { value: 3, text: 'Não aceitar pagamento com valor divergente' },
    { value: 4, text: 'Somente valor mínimo' }
  ],
  TipoPerfilOperador: {
    Nenhum: 0,
    Administrador: 1,
    Operador: 1 << 1,
    // 1 << 1,
    Consulta: 1 << 2,
    // 1 << 2
    Contabil: 1 << 3
    // 1 << 2
  },
  TipoPerfilOperadorRetaguarda: {
    Nenhum: 0,
    Consulta: 1,
    Administrador: 1 << 1
  },
  Especie: [
    { value: 1, text: 'CH Cheque' },
    { value: 2, text: 'DM Duplicata Mercantil' },
    { value: 3, text: 'DMI Duplicata Mercantil Indicação' },
    { value: 4, text: 'DS Duplicata de Serviço' },
    { value: 5, text: 'DSI Duplicata de Serviço Indicação' },
    { value: 6, text: 'DR Duplicata Rural' },
    { value: 7, text: 'LC Letra de Câmbio' },
    { value: 8, text: 'NCC Nota de Crédito Comercial' },
    { value: 9, text: 'NCE Nota de Crédito Exportação' },
    { value: 10, text: 'NCI Nota de Crédito Industrial' },
    { value: 11, text: 'NCR Nota de Crédito Rural' },
    { value: 12, text: 'NP Nota Promissória' },
    { value: 13, text: 'NPR Nota Promissória Rural' },
    { value: 14, text: 'TM Triplicata Mercantil' },
    { value: 15, text: 'TS Triplicata de Serviço' },
    { value: 16, text: 'NS Nota de Seguro' },
    { value: 17, text: 'RC Recibo' },
    { value: 18, text: 'FAT Bloqueto' },
    { value: 19, text: 'ND Nota de Débito' },
    { value: 20, text: 'AP Apólice de Seguro' },
    { value: 21, text: 'ME Mensalidade Escolar' },
    { value: 22, text: 'PC Parcela de Consórcio' },
    { value: 23, text: 'NF Nota Fiscal' },
    { value: 24, text: 'DD Documento de Dívida' },
    { value: 25, text: 'Cédula de Produto Rural' },
    { value: 26, text: 'Warrant' },
    { value: 27, text: 'Dívida Ativa de Estado' },
    { value: 28, text: 'Dívida Ativa de Município' },
    { value: 29, text: 'Dívida Ativa da União' },
    { value: 30, text: 'Encargos condominiais' },
    { value: 31, text: 'Cartão de Crédito' },
    { value: 32, text: 'Boleto proposta' },
    { value: 99, text: 'Outros' }
  ],
  OrigemPagamento: [
    { value: 2, text: '2 - Auto Atendimento' },
    { value: 13, text: '13 - Telefone' },
    { value: 14, text: '14 - Internet Banking' },
    { value: 73, text: '73 - Arquivo Eletrônico' },
    { value: 74, text: '74 - Guichê Caixa' },
    { value: 75, text: '75 - Correspondente' },
    { value: 99, text: '99 - Não definido' }
  ],
  CanalPagamento: [
    { value: 1, text: '1 - Agências' },
    { value: 2, text: '2 - Auto Atendimento' },
    { value: 3, text: '3 - Internet' },
    { value: 5, text: '5 - Correspondente Bancário' },
    { value: 6, text: '6 - CallCenter' },
    { value: 7, text: '7 - ArquivoEletronico' },
    { value: 8, text: '8 - DDA' }
  ],
  BoletoModalidade: [
    { value: 1, text: 'Cobrança Simples' },
    { value: 2, text: 'Cobrança Vinculada' },
    { value: 3, text: 'Cobrança Caucionada' },
    { value: 4, text: 'Cobrança Descontada' },
    { value: 5, text: 'Cobrança Vendor' }
  ],
  SituacaoBloqueioConta: [
    { value: 'Todas', text: 'Todas' },
    { value: 1, text: 'Com Bloqueio' },
    { value: 2, text: 'Sem Bloqueio' }
  ],
  SituacaoSaldoConta: [
    { value: 'Todas', text: 'Todos' },
    { value: 1, text: 'Positivo' },
    { value: 2, text: 'Negativo' }
  ],
  FinalizacaoSolicitacao: [
    { value: 1, text: 'Aprovar' },
    { value: 2, text: 'Pendenciar' },
    { value: 3, text: 'Cancelar' }
  ],
  BoletoEspecie: [
    { value: 1, text: 'CH Cheque' },
    { value: 2, text: 'DM Duplicata Mercantil' },
    { value: 3, text: 'DMI Duplicata Mercantil Indicação' },
    { value: 4, text: 'DS Duplicata de Serviço' },
    { value: 5, text: 'DSI Duplicata de Serviço Indicação' },
    { value: 6, text: 'DR Duplicata Rural' },
    { value: 7, text: 'LC Letra de Câmbio' },
    { value: 8, text: 'NCC Nota de Crédito Comercial' },
    { value: 9, text: 'NCE Nota de Crédito Exportação' },
    { value: 10, text: 'NCI Nota de Crédito Industrial' },
    { value: 11, text: 'NCR Nota de Crédito Rural' },
    { value: 12, text: 'NP Nota Promissória' },
    { value: 13, text: 'NPR Nota Promissória Rural' },
    { value: 14, text: 'TM Triplicata Mercantil' },
    { value: 15, text: 'TS Triplicata de Serviço' },
    { value: 16, text: 'NS Nota de Seguro' },
    { value: 17, text: 'RC Recibo' },
    { value: 18, text: 'FAT Bloqueto' },
    { value: 19, text: 'ND Nota de Débito' },
    { value: 20, text: 'AP Apólice de Seguro' },
    { value: 21, text: 'ME Mensalidade Escolar' },
    { value: 22, text: 'PC Parcela de Consórcio' },
    { value: 23, text: 'NF Nota Fiscal' },
    { value: 24, text: 'DD Documento de Dívida' },
    { value: 25, text: 'Cédula de Produto Rural' },
    { value: 26, text: 'Warrant' },
    { value: 27, text: 'Dívida Ativa de Estado' },
    { value: 28, text: 'Dívida Ativa de Município' },
    { value: 29, text: 'Dívida Ativa da União' },
    { value: 30, text: 'Encargos condominiais' },
    { value: 31, text: 'Cartão de Crédito' },
    { value: 32, text: 'Boleto proposta' },
    { value: 99, text: 'Outros' }
  ],
  SituacaoBoleto: [
    { value: 0, text: 'Todos' },
    { value: 1, text: 'Pendente Registro' },
    { value: 2, text: 'Registrado' },
    { value: 3, text: 'Erro Registro' },
    { value: 4, text: 'Pago' },
    { value: 5, text: 'Baixado Cedente' },
    { value: 6, text: 'Baixado Data Limite Pagto' },
    { value: 7, text: 'Pendente Baixa Cedente' },
    { value: 8, text: 'Pendente Protesto' },
    { value: 9, text: 'Protestado' },
    { value: 10, text: 'Pago Em Cartório' }
  ],
  SituacaoPiloto: [
    { value: null, text: 'Pendente' },
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Conferido' },
    { value: 2, text: 'Confirmado' },
    { value: 3, text: 'Creditado' },
    { value: 98, text: 'ErroInterno' },
    { value: 99, text: 'Erro' }
  ],
  ApiOrigem: [
    { value: 0, text: 'BackOffice' },
    { value: 1, text: 'API FrontEnd' },
    { value: 2, text: 'API Externa' },
    { value: 3, text: 'Retaguarda' },
    { value: 4, text: 'Onboarding' },
    { value: 5, text: 'Onboarding Múltiplo' },
    { value: 99, text: 'Outros' }
  ],
  SituacaoTransacao: [
    { value: 0, text: '0 - Pendente' },
    { value: 1, text: '1 - Registrando' },
    { value: 2, text: '2 - Registrado' },
    { value: 3, text: '3 - Cancelado' },
    { value: 4, text: '4 - Confirmado' },
    { value: 50, text: '50 - Pendente Reprocessamento' },
    { value: 97, text: '97 - Não Processada' },
    { value: 98, text: '98 - Erro de Negocio' },
    { value: 99, text: '99 - Erro de Sistema' }
  ],
  OrigemTransacao: [
    { value: 0, text: '0 - Outros Movtos' },
    { value: 1, text: '1 - Transf. Entre Contas' },
    { value: 2, text: '2 - TED Enviada' },
    { value: 3, text: '3 - Pagamento Boleto' },
    { value: 4, text: '4 - Transf. Entre CR.' },
    { value: 501, text: '501 - Transf. Entre Contas' },
    { value: 502, text: '502 - TED Recebida' },
    { value: 503, text: '503 - Boleto Recebido' },
    { value: 504, text: '504 - Transf. CR.' },
    { value: 1001, text: '1001 - Dev. Transf.' },
    { value: 1002, text: '1002 - TED Devolvida' },
    { value: 1003, text: '1003 - Dev. Boleto' },
    { value: 1004, text: '1004 - Dev. Transf. CR.' },
    { value: 1501, text: '1501 - Registro Boleto' },
    { value: 1502, text: '1502 - Alteracao Boleto' },
    { value: 1503, text: '1503 - Cancelamento Boleto' },
    { value: 2001, text: '2001 - Arq. CNAB Registro' },
    { value: 2002, text: '2002 - Arq. CNAB Pagamento Boletos' },
    { value: 2003, text: '2003 - Arq. CNAB Alteração Boletos' },
    { value: 2004, text: '2004 - Arq. CNAB Cancelamento Boletos' },
    { value: 2501, text: '2501 - Split' },
    { value: 3001, text: '3001 - Serviço' },
    { value: 4001, text: '4001 - Safe' },
    { value: 4501, text: '4501 - Prévia Boleto Crédito' }
  ],
  OrigemTransacaoTransferenciaCedente: [
    { value: 2005, text: 'Arq. CNAB Troca de cedente' }
  ],
  MetodoHttp: [
    { value: null, text: 'Selecione' },
    { value: 0, text: 'GET' },
    { value: 1, text: 'POST' },
    { value: 2, text: 'PUT' },
    { value: 3, text: 'DELETE' },
    { value: 4, text: 'HEAD' },
    { value: 5, text: 'OPTIONS' },
    { value: 6, text: 'PATCH' },
    { value: 7, text: 'MERGE' },
    { value: 8, text: 'COPY' }
  ],
  DiasSemana: [
    { value: 0, text: 'Domingo' },
    { value: 1, text: 'Segunda-Feira' },
    { value: 2, text: 'Terça-Feira' },
    { value: 3, text: 'Quarta-Feira' },
    { value: 4, text: 'Quinta-Feira' },
    { value: 5, text: 'Sexta-Feira' },
    { value: 6, text: 'Sábado' }
  ],
  OrigemNossoNumero: [
    { value: 1, text: 'BMP' },
    { value: 2, text: 'Cliente' }
  ],
  EstadoCivil: [
    { value: 1, text: 'Solteiro(a)' },
    { value: 2, text: 'Casado(a)' },
    { value: 3, text: 'Desquitado(a)' },
    { value: 4, text: 'Divorciado(a)' },
    { value: 5, text: 'Separado(a)' },
    { value: 6, text: 'Viúvo(a)' },
    { value: 7, text: 'Outros' },
    { value: 8, text: 'Não Informado' },
    { value: 9, text: 'Vinculo Conjugal' }
  ],
  TiposSplit: [
    { value: 1, text: 'Percentual' },
    { value: 2, text: 'Valor' }
  ],
  IndicadorBoleano: [
    { value: null, text: 'Não' },
    { value: 1, text: 'Sim' }
  ],
  IndicadorPEP: [
    { value: 1, text: 'Sim' },
    { value: 2, text: 'Não' }
  ],
  TipoRegistro: [
    { value: 1, text: 'Online' },
    { value: 2, text: 'Offline' },
    { value: 3, text: 'CNAB' }
  ],
  TipoOperacao: [
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Tarifário' },
    { value: 3, text: 'Split' },
    { value: 4, text: 'Transitória' }
  ],
  TipoOperacaoOnboarding: [
    { value: 1, text: 'Empréstimo' },
    { value: 2, text: 'Garantia' },
    { value: 3, text: 'Cessão' },
    { value: 4, text: 'Desconto' },
    { value: 5, text: 'Limite Crédito' },
    { value: 6, text: 'Antecipação Recebíveis' },
    { value: 99, text: 'Outros' }
  ],
  TipoRecebTED: [
    { value: 1, text: 'Somente Correntista Principal' },
    { value: 2, text: 'Todos Correntistas' }
  ],
  CodMoeda: [
    { value: 1, text: 'Reservado para uso futuro' },
    { value: 2, text: 'Dólar Americano Comercial (Venda)' },
    { value: 3, text: 'Dólar Americano Turismo (Venda)' },
    { value: 4, text: 'ITRD' },
    { value: 5, text: 'IDTR' },
    { value: 6, text: 'UFIR Diária' },
    { value: 7, text: 'UFIR Mensal' },
    { value: 8, text: 'FAJ-TR' },
    { value: 9, text: 'Real' },
    { value: 10, text: 'TR' },
    { value: 11, text: 'IGPM' },
    { value: 12, text: 'CDI' },
    { value: 13, text: 'Percentual do CDI' },
    { value: 14, text: 'Euro' },
    { value: 15, text: 'CDI-CETIP' },
    { value: 16, text: 'CHF' },
    { value: 17, text: 'CUB/RS(NOVO)' },
    { value: 18, text: 'CUB/RS(R8-N)' },
    { value: 19, text: 'CUB/SC (ANTIGO)' },
    { value: 20, text: 'CUBRS' },
    { value: 21, text: 'CUB-SC (NOVO)' },
    { value: 22, text: 'GBP' },
    { value: 23, text: 'ICC (SALVADOR)' },
    { value: 24, text: 'IGPM (A)' },
    { value: 25, text: 'IGPM (N)' },
    { value: 26, text: 'INCC' },
    { value: 27, text: 'INCC-M' },
    { value: 28, text: 'INPC' },
    { value: 29, text: 'JPY' },
    { value: 30, text: 'TJLP' }
  ],
  SituacaoTituloPgto: [
    { value: 1, text: 'Boleto já baixado' },
    { value: 2, text: 'Boleto bloqueado para pagamento' },
    {
      value: 3,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário inapto na Instituição emissora do título'
    },
    {
      value: 4,
      text: 'Boleto encontrado na base e cliente Beneficiário sem cadastro'
    },
    {
      value: 5,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário em análise na Instituição emissora do título'
    },
    { value: 6, text: 'Boleto excedeu o limite de pagamentos parciais' },
    { value: 7, text: 'Baixa operacional integral já registrada' },
    {
      value: 9,
      text: 'Boleto excedeu o valor de saldo para pagamento parcial para o tipo de modelo de cálculo 04'
    },
    {
      value: 10,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário inapto em Instituição diferente da emissora'
    },
    {
      value: 11,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário em análise em Instituição diferente da emissora'
    },
    {
      value: 12,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário apto'
    }
  ],
  SituacaoContabil: [
    { value: 1, text: 'Ativa' },
    { value: 2, text: 'Inativa' }
  ],
  TipoBuscaOperacao: [
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Tarifario' },
    { value: 3, text: 'Transitoria' },
    { value: 4, text: 'Split' }
  ],
  Escolaridade: [
    { value: 1, text: 'Cursando Educação Infantil' },
    { value: 2, text: 'Educação Infantil Completa' },
    { value: 3, text: 'Cursando Ensino Fundamental' },
    { value: 4, text: 'Ensino Fundamental Completo' },
    { value: 5, text: 'Cursando Ensino Médio' },
    { value: 6, text: 'Ensino Médio Completo' },
    { value: 7, text: 'Cursando Ensino Superior' },
    { value: 8, text: 'Ensino Superior Completo' },
    { value: 9, text: 'Cursando Especialização' },
    { value: 10, text: 'Especialização Completa' },
    { value: 11, text: 'Cursando Mestrado' },
    { value: 12, text: 'Mestrado Completo' },
    { value: 13, text: 'Cursando Doutorado' },
    { value: 14, text: 'Doutorado Completo' },
    { value: 15, text: 'Cursando Pos Doutorado' },
    { value: 16, text: 'Pos Doutorado Completo' },
    { value: 17, text: 'Analfabeto' },
    { value: 18, text: 'Sem instrução escolar' }
  ],
  SituacaoSolicitacaoEncerramentoConta: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Confirmada' },
    { value: 3, text: 'Rejeitada' },
    { value: 4, text: 'Cancelada' }
  ],
  ComparativoBureau: [
    { value: 1, text: 'Conforme' },
    { value: 2, text: 'Não conforme' },
    { value: 3, text: 'Atenção' },
    { value: 4, text: 'Menor de 18 anos' }
  ],
  MotivoEncerramento: [
    { value: 1, text: 'Encerramento por desinteresse comercial' },
    { value: 2, text: 'Encerramento a pedido do titular da conta' },
    { value: 3, text: 'Encerramento prevenção a fraude' },
    { value: 4, text: 'Encerramento solicitado pelo Comitê Compliance' },
    { value: 5, text: 'Encerramento por decisão judicial' },
    { value: 6, text: 'Encerramento por cancelamento de operação' },
    { value: 7, text: 'Encerramento por cobrança de tarifa' },
    {
      value: 8,
      text: 'Encerramento por não reconhecimento de conta pagamento'
    },
    { value: 9, text: 'Encerramento por falta de atendimento' },
    { value: 10, text: 'Outros' }
  ],
  OrigemLogTarifario: [
    { value: 1, text: 'Inserção' },
    { value: 2, text: 'Alteração' }
  ],
  SituacaoRelatorio: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Processando' },
    { value: 3, text: 'Processado' },
    { value: 4, text: 'Erro' }
  ],
  TipoBoleto: [
    { value: 1, text: 'Híbrido' },
    { value: 2, text: 'CIP' }
  ],
  TipoRelatorio: [
    { value: 1, text: 'Relatório de Boletos Registrados' },
    { value: 2, text: 'Movimentações por Conta' },
    { value: 3, text: 'Exportação Contabilização' },
    { value: 4, text: 'Extrato Conta' },
    { value: 6, text: 'Consulta Boleto' },
    { value: 18, text: 'Tarifa Recorrente' },
    { value: 19, text: 'Tarifário' },
    { value: 25, text: 'Split' },
    { value: 26, text: 'DDA Pagador Eletrônico' },
    { value: 28, text: 'Cessão Boleto' }
  ],
  TipoArquivoRelatorio: [
    { value: 1, text: 'PDF' },
    { value: 2, text: 'CSV' },
    { value: 3, text: 'XLSX' },
    { value: 5, text: 'OFX' }
  ],
  OperadorPrincipal: [
    { value: true, text: 'Sim' },
    { value: false, text: '' }
  ],
  TipoCadastroFavorecido: [
    { value: 1, text: 'Transferência e TED' },
    { value: 2, text: 'PIX' }
  ],
  TipoCadastroPix: [
    { value: 1, text: 'Chave' },
    { value: 2, text: 'Dados Bancários' }
  ],
  TipoChavePixFavorecido: [
    { value: 0, text: 'CPF' },
    { value: 1, text: 'CNPJ' },
    { value: 2, text: 'Telefone' },
    { value: 3, text: 'Email' },
    { value: 4, text: 'EVP' }
  ],
  ModeloConta: [
    { value: null, text: 'Todos' },
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Escrow' },
    { value: 3, text: 'Vinculada' }
  ],
  TipoPreenchimento: [
    { value: 1, text: 'Escrow' },
    { value: 2, text: 'Titular' },
    { value: 3, text: 'Parceiro' },
    { value: 4, text: 'Empresa' }
  ],
  ToastMessagesAnaliseCadastral: [
    {
      value: 0,
      text: 'Há uma análise com os parâmetros informados pendente. Aguarde a conclusão para realizar uma nova solicitação',
      type: 'Error'
    },
    {
      value: 1,
      text: 'Solicitação de criação enviada para análise',
      type: 'Alert'
    },
    { value: 2, text: 'Criação realizada com sucesso', type: 'Success' },
    {
      value: 3,
      text: 'Solicitação de edição enviada para análise',
      type: 'Alert'
    },
    { value: 4, text: 'Edição realizada com sucesso', type: 'Success' },
    {
      value: 5,
      text: 'Solicitação de vínculo enviada para análise',
      type: 'Alert'
    },
    { value: 6, text: 'Vínculo realizado com sucesso', type: 'Success' }
  ],
  DiasSemana: [
    { value: 0, text: 'Nenhum' },
    { value: 1, text: 'Segunda-Feira' },
    { value: 1 << 1, text: 'Terça-Feira' },
    { value: 1 << 2, text: 'Quarta-Feira' },
    { value: 1 << 3, text: 'Quinta-Feira' },
    { value: 1 << 4, text: 'Sexta-Feira' },
    { value: 1 << 5, text: 'Sábado' },
    { value: 1 << 6, text: 'Domingo' }
  ],
  TipoAcesso: [
    { value: 1, text: 'Master' },
    { value: 2, text: 'Operador' }
  ],
  TipoAcessoFrontEnd: [
    { value: 1, text: 'Padrão' },
    { value: 2, text: 'Personalizado' }
  ],
  TipoPermissaoGestaoAcesso: [
    { value: 1, text: 'DBS.IB.Master' },
    { value: 2, text: 'DBS.IB.VTransacoes' },
    { value: 3, text: 'DBS.IB.IAETransacoes' },
    { value: 4, text: 'DBS.IB.ATransacoes' },
    { value: 5, text: 'DBS.IB.VExtrato' },
    { value: 6, text: 'DBS.IB.VLimite' },
    { value: 7, text: 'DBS.IB.IALimite' },
    { value: 8, text: 'DBS.IB.VIEmissao' },
    { value: 9, text: 'DBS.IB.VGestaoCobranca' },
    { value: 10, text: 'DBS.IB.IAEGestaoCobranca' },
    { value: 11, text: 'DBS.IB.AGestaoCobranca' },
    { value: 12, text: 'DBS.IB.VTarifas' }
  ],
  TipoProgramacao: [
    { value: 1, text: 'Programada Total' },
    { value: 2, text: 'Programada Valor' },
    { value: 3, text: 'Programada Percentual' }
  ],
  TipoBiometria: [
    { value: 1, text: 'Onboarding' },
    { value: 2, text: 'Autenticação Facial' }
  ],
  TipoDocumentoEmpresa: [
    { value: 1, text: 'MEI' },
    { value: 2, text: 'Empresário Individual' },
    { value: 3, text: 'Sociedade Limitada Unipessoal' },
    { value: 4, text: 'Sociedade Empresária Limitada' },
    { value: 5, text: 'Sociedade Simples' },
    { value: 6, text: 'Sociedade Anônima' },
    { value: 7, text: 'Sociedade Cooperativa' },
    { value: 8, text: 'Sociedade de Associação Privada' },
    { value: 9, text: 'Condomínio Edifício' }
  ],
  TipoHorarioRepasseSaldo: [
    { value: 1, text: 'Automático' },
    { value: 2, text: 'Personalizado' }
  ],
  TipoVinculoConta: [
    { value: 1, text: 'Operador' },
    { value: 2, text: 'Correntista' }
  ],
  TipoSocio: [
    { value: 1, text: 'Parceiro' },
    { value: 2, text: 'Procurador' },
    { value: 3, text: 'Representante Legal' },
    { value: 4, text: 'Outro' }
  ],
  SituacaoOnboarding: [
    { value: 1, text: 'Em análise' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' },
    { value: 4, text: 'Em consulta' }
  ],
  SituacaoAnaliseDocumento: [
    { value: 1, text: 'Documento em análise' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' },
    { value: 4, text: 'Pendente' }
  ],
  TipoInformacao: [
    { value: 1, text: 'Correntista' },
    { value: 2, text: 'Socio' },
    { value: 3, text: 'Bureau' },
    { value: 4, text: 'ControladorDaConta' },
    { value: 5, text: 'Biometria' },
    { value: 6, text: 'Credor' },
    { value: 7, text: 'Operador' }
  ],
  TipoEmpresa: [
    { value: 1, text: 'FIDC' },
    { value: 2, text: 'Factory' },
    { value: 3, text: 'Securitizadora' },
    { value: 4, text: 'Outros' },
    { value: 5, text: 'Titular' },
    { value: 6, text: 'Credor' },
    { value: 7, text: 'Administrador' },
    { value: 8, text: 'Consultoria Especializada' },
    { value: 9, text: 'Agente Depositário' }
  ],
  SituacaoAnaliseCadastralConta: [
    { value: 1, text: 'Aguardando ativação' },
    { value: 2, text: 'Aprovada' },
    { value: 3, text: 'Reprovada' },
    { value: 4, text: 'Em consulta' },
    { value: 5, text: 'Cancelada' },
    { value: 6, text: 'Aguardando análise' },
    { value: 7, text: 'Recusada' },
    { value: 13, text: 'Pendente processamento da análise' },
    { value: 14, text: 'Pendente de análise manual' },
    { value: 15, text: 'Reprovado na análise' }
  ],
  SituacaoExecucao: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Executando' },
    { value: 3, text: 'Executado' },
    { value: 4, text: 'Ignorado' },
    { value: 5, text: 'Validado' },
    { value: 99, text: 'Erro Sistema' }
  ],
  TipoBureau: [
    { value: 1, text: 'Cadastro restritivo' },
    { value: 2, text: 'Indício de fraude' },
    { value: 3, text: 'Óbito e fiscal' },
    { value: 4, text: 'Mídia desabonadora' },
    { value: 5, text: 'E-mail age' },
    { value: 6, text: 'Análise restritiva' },
    { value: 7, text: 'Criminal detalhe' },
    { value: 8, text: 'Segban' },
    { value: 14, text: 'Análise cadastral detalhada' },
    { value: 15, text: 'Análise cadastral detalhada PJ' },
    { value: 16, text: 'Análise cadastral simplificada' },
    { value: 17, text: 'Análise cadastral simplificada PJ' },
    { value: 18, text: 'AntiFraude' }
  ],
  TipoPermissao: [
    { value: 1, text: 'Criação' },
    { value: 2, text: 'Edição' },
    { value: 4, text: 'Criação Vínculo' },
    { value: 5, text: 'Edição Vínculo' }
  ],
  ContextoOnboarding: [
    { value: 0, text: 'Nenhum' },
    { value: 1, text: 'Correntista' },
    { value: 2, text: 'Operador Backoffice' },
    { value: 3, text: 'Operador Retaguarda' },
    { value: 4, text: 'Operador Frontend' },
    { value: 5, text: 'KYC Operador Retaguarda' },
    { value: 6, text: 'KYC Operador FrontEnd' },
    { value: 7, text: 'Correntista PJ' },
    { value: 8, text: 'Sócio Correntista PJ' }
  ],
  DescricaoValidacaoOnboardingDetalhe: [
    { value: 1, text: 'Análise pendente de validação' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Análise contém restrição' },
    {
      value: 98,
      text: 'Validação não encontrada, realize a consulta do bureau novamente'
    },
    { value: 99, text: 'Ocorreu um erro inesperado na análise' }
  ],
  TipoArquivoSocio: [
    { value: 1, text: 'Procuração' },
    { value: 2, text: 'Identificação' }
  ],
  ResponsabilidadeSocio: [
    { value: 1, text: 'Sócio' },
    { value: 2, text: 'Diretor' },
    { value: 3, text: 'Procurador' },
    { value: 4, text: 'Gerente' },
    { value: 5, text: 'Coordenador' }
  ],
  TipoAssinaturaSocio: [
    { value: 1, text: 'Assina isoladamente' },
    { value: 2, text: 'Assina em conjunto' },
    { value: 3, text: 'Não Assina' }
  ],
  SituacaoTransacionalCartao: [
    { value: 'Todas', text: 'Todas' },
    { value: 0, text: 'Recusado' },
    { value: 1, text: 'Aprovado' }
  ],
  SituacaoOperadorConta: [
    { value: 1, text: 'Em análise' },
    { value: 2, text: 'Aguardando biometria' },
    { value: 3, text: 'Cancelado' },
    { value: 4, text: 'Reprovado' },
    { value: 5, text: 'Ativo' },
    { value: 6, text: 'Inativo' },
    { value: 7, text: 'Excluído' }
  ],
  TipoTransacaoComprovante: [
    { value: 1, text: 'Transferência' },
    { value: 2, text: 'Transferência - conta reserva' },
    { value: 3, text: 'TED' },
    { value: 4, text: 'Boleto' },
    { value: 5, text: 'Boleto - concessionária' },
    { value: 6, text: 'PIX' },
    { value: 7, text: 'Devolucão Pix' },
    { value: 8, text: 'TED - STR0025' }
  ],
  AcaoCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Enviado' },
    { value: 2, text: 'Recebido' }
  ],
  FinalidadeCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Desconto' },
    { value: 2, text: 'Caução' }
  ],
  SituacaoCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Aguardando aprovação pelo correntista' },
    { value: 2, text: 'Aguardando aceite pelo novo cedente' },
    { value: 3, text: 'Aceita pelo novo cedente' },
    { value: 4, text: 'Rejeitada pelo novo cedente' },
    { value: 5, text: 'Solicitação cancelada' },
    { value: 6, text: 'Aguardando aprovação de devolução pelo correntista' },
    { value: 7, text: 'Devolvida para o cedente anterior' },
    { value: 8, text: 'Cedida para um novo cedente' },
    { value: 9, text: 'Finalizada com crédito' },
    { value: 10, text: 'Reprovada pelo cedente atual' },
    { value: 11, text: 'Aguardando aprovação de aceite pelo novo cedente' }
  ],
  StatusDuplicataAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'A vencer' },
    { value: 1, text: 'Vencida' },
    { value: 2, text: 'Cancelada' },
    { value: 3, text: 'Liquidada integral' },
    { value: 4, text: 'Liquidada parcial' },
    { value: 5, text: 'Liquidada com juros' },
    { value: 6, text: 'Escrituração pendente' },
    { value: 7, text: 'Escriturada' },
    { value: 8, text: 'Escrituração com erro' },
    { value: 9, text: 'Liquidada' },
    { value: 10, text: 'Protestada' },
    { value: 11, text: 'Bloqueada pelo sacador' },
    { value: 12, text: 'Bloqueada por constrição judicial' },
    { value: 13, text: 'Emitida' }
  ],
  StatusNegociacaoAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'Recebida' },
    { value: 1, text: 'Enviada' },
    { value: 2, text: 'Cancelada' },
    { value: 3, text: 'Recusada' },
    { value: 4, text: 'Processando' },
    { value: 5, text: 'Aguardando pagamento' },
    { value: 6, text: 'Concluída' },
    { value: 7, text: 'Erro' }
  ],
  DisponibilidadeAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'Disponível' },
    { value: 1, text: 'Indisponível' },
    { value: 2, text: 'Em negociação' },
    { value: 3, text: 'Erro' }
  ],
  DetalheDisponibilidadeAgenda: [
    { value: 0, text: 'Livre para negociar' },
    { value: 1, text: 'Bloqueada na escrituradora' },
    { value: 2, text: 'Duplicata comprometida' },
    { value: 4, text: 'Fora das políticas' }
  ],
  DetalheStatusNegociacaoAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'Aguardando financiador' },
    { value: 1, text: 'Aguardando cedente' },
    { value: 2, text: 'Cancelada pelo cedente' },
    { value: 3, text: 'Cancelada pelo financiador' },
    { value: 4, text: 'Cancelada automaticamente' },
    { value: 5, text: 'Recusada pelo cedente' },
    { value: 6, text: 'Recusada pelo financiador' },
    { value: 7, text: 'Recusada pela escrituradora' },
    { value: 8, text: 'Processando negociação' },
    { value: 9, text: 'Processando cancelamento' },
    { value: 10, text: 'Pagamento pendente - Aguardando confirmação do financiador' },
    { value: 11, text: 'Concluída - Registro e pagamento confirmados' }
  ],
  RespostaPagadorAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Aceita' },
    { value: 2, text: 'Recusada' }
  ],
  MeioPagamentoAgenda: [
    { value: null, text: 'Não definido' },
    { value: 0, text: 'Boleto' },
    { value: 1, text: 'Transferência' },
    { value: 2, text: 'Pix' }
  ],
  RatingAgenda: [
    { value: null, text: 'Sem rating' },
    { value: 'A', text: 'A' },
    { value: 'B', text: 'B' },
    { value: 'C', text: 'C' },
    { value: 'D', text: 'D' },
    { value: 'E', text: 'E' }
  ]
})
